export const previewPlans = [
  {
    plan_name: "Lowest Monthly Rate",
    primary_color: "#5B21B6",
    months: 24,
    rate: 0.4,
    fees: [],
  },
  {
    plan_name: "Most Popular",
    primary_color: "#30471D",
    months: 18,
    rate: 0.4,
    fees: [],
  },
  {
    plan_name: "Fastest Payoff",
    primary_color: "#C2410C",
    rate: 0.02,
    months: 3,
    fees: [],
  },
];
